import { createContext, useContext, useState } from "react";
import { ChevronDown, Gem } from "lucide-react";

export const COMMODITIES = [
  { key: "diamond", label: "Diamonds", brand: "Virtus Diamond Registry", prefix: "VDR" },
  { key: "gold", label: "Gold", brand: "Virtus Gold Registry", prefix: "VGR" },
  { key: "platinum", label: "Platinum", brand: "Virtus Platinum Registry", prefix: "VPR" },
  { key: "silver", label: "Silver", brand: "Virtus Silver Registry", prefix: "VSR" },
  { key: "other", label: "Other Commodities", brand: "Virtus Commodity Registry", prefix: "VCR" },
];

const Ctx = createContext(null);

export function CommodityProvider({ children }) {
  const [commodity, setCommodityState] = useState(() => localStorage.getItem("vdr_commodity") || "diamond");
  const setCommodity = (k) => { localStorage.setItem("vdr_commodity", k); setCommodityState(k); };
  const meta = COMMODITIES.find((c) => c.key === commodity) || COMMODITIES[0];
  return <Ctx.Provider value={{ commodity, setCommodity, brand: meta.brand, meta }}>{children}</Ctx.Provider>;
}

export const useCommodity = () => useContext(Ctx);

export function BrandSwitcher({ compact = false }) {
  const { commodity, setCommodity, brand } = useCommodity();
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} data-testid="brand-switcher"
        className={`inline-flex items-center gap-1.5 rounded-sm border border-bb-gold/30 text-bb-gold hover:bg-bb-gold/10 transition-colors ${compact ? "px-2 py-1 text-[0.6rem]" : "px-3 py-1.5 text-[0.68rem]"} uppercase tracking-[0.12em]`}>
        <Gem size={compact ? 10 : 12} /> {compact ? brand.replace("Virtus ", "").replace(" Registry", "") : brand}
        <ChevronDown size={compact ? 10 : 12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 top-full mt-1.5 z-50 bg-bb-surface border border-bb-gold/25 rounded-sm shadow-xl min-w-[230px]" data-testid="brand-switcher-menu">
          {COMMODITIES.map((c) => (
            <button key={c.key} onClick={() => { setCommodity(c.key); setOpen(false); }}
              data-testid={`brand-option-${c.key}`}
              className={`block w-full text-left px-4 py-2.5 text-xs transition-colors ${commodity === c.key ? "text-bb-gold bg-bb-gold/[0.08]" : "text-bb-text/80 hover:bg-white/[0.04]"}`}>
              <div className="font-medium">{c.brand}</div>
              <div className="text-bb-dim text-[0.62rem] mt-0.5">{c.label} · IDs {c.prefix}-YYYY-######</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
